module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/badge/image-badge/image-badge.component.scss
// module id = ./src/app/features/badge/image-badge/image-badge.component.scss
// module chunks = main